export default {
    results: {
        missingTerms: "Missing terms:",
        resultsCount: "{count, plural, =0 {no results} one {# result} other {# results}}",
    },
    userRatings: {
        average: "Average: {average}"
    },
};
